import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { UX2 } from '@wsb/guac-widget-core';
import DataAid from './constants/data-aids';

class NoEventText extends Component {
  static get propTypes() {
    return {
      id: PropTypes.string.isRequired,
      locale: PropTypes.string,
      renderMode: PropTypes.string.isRequired,
      env: PropTypes.string.isRequired,
      category: PropTypes.string,
      className: PropTypes.string,
      sectionTitle: PropTypes.string,
      icalURL: PropTypes.string,
      accountId: PropTypes.string.isRequired,
      websiteId: PropTypes.string.isRequired,
      pageId: PropTypes.string.isRequired,
      anchorId: PropTypes.string,
      staticContent: PropTypes.object.isRequired,
      isManual: PropTypes.bool.isRequired,
      visitorMode: PropTypes.bool
    };
  }

  render() {
    const { isManual, visitorMode, staticContent = {} } = this.props;
    const message = staticContent[visitorMode || isManual ? 'editNoEvents' : 'publishNoEvents'];
    return (
      <UX2.Component.Grid bottom={ false }>
        <UX2.Component.Grid.Cell>
          <UX2.Element.Heading
            tag='h4'
            data-aid={ DataAid.CALENDAR_NO_EVENT_MSG }
            style={{ textAlign: 'center' }}
          >
            { message }
          </UX2.Element.Heading>
        </UX2.Component.Grid.Cell>
      </UX2.Component.Grid>
    );
  }
}

export default NoEventText;
